import { createValidation } from '_metronic/helpers'
import { TFunction } from '_metronic/i18n/Metronici18n'
import * as Yup from 'yup'

export const telekitSchema = (t: TFunction) => {
  const v = createValidation(t)

  return Yup.object().shape({
    empresa: Yup.object().nullable().required(v.requiredField('empresa', 'select')),
    ativo: Yup.object().nullable().required('Status é obrigatório.'),
    identificador: Yup.number()
      .typeError('Identificador deve ser um número')
      .integer('Deve ser um número inteiro')
      .required('Identificador é obrigatório'),

    idPulsus: Yup.number()
      .typeError('ID Pulsus deve ser um número')
      .integer('Deve ser um número inteiro')
      .required('ID Pulsus é obrigatório'),
  })
}
